import { Wrapper } from './Loader.style';

type LoaderProps = {
  width: number;
  height: number;
  thickness: number;
  outerColor?: string;
  innerColor?: string;
  extendStyle?: [] | string;
};

const Loader: React.FC<LoaderProps> = ({
  width,
  height,
  thickness,
  outerColor,
  innerColor,
  extendStyle,
  ...props
}) => (
  <Wrapper
    width={width}
    height={height}
    thickness={thickness}
    outerColor={outerColor!}
    innerColor={innerColor!}
    extendStyle={extendStyle!}
    {...props}
  />
);

export default Loader;
